/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	import Cmd = alm.util.Cmd;
	import EventDispatcher = alm.event.EventDispatcher;

	export class Sequencer extends EventDispatcher {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		public constructor() {
			super();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public start():void {
			Cmd.stop(this.sequence);
			this.sequence = new cmd.Serial(

				// opening
				new cmd.Func(():void => {
				}),

				// visualization
				new cmd.Func(():void => {
				}),

				// ending
				new cmd.Func(():void => {
				}),
			);
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private sequence:cmd.Serial;
	}
}
